function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "--copy-4",
  transform: "translate(-1664.000000, -1185.000000)",
  fill: "#DD2E44",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "close",
  transform: "translate(1664.000000, 1185.000000)"
}, React.createElement("g", {
  id: "Group",
  transform: "translate(12.500000, 12.500000) scale(-1, 1) rotate(-180.000000) translate(-12.500000, -12.500000) "
}, React.createElement("g", {
  id: "Shape"
}, React.createElement("path", {
  d: "M15.1791223,12.3208538 L24.434109,21.4312313 C25.1732048,22.1580587 25.1732048,23.3368871 24.434109,24.063649 C23.6957447,24.7911964 22.4990027,24.7911964 21.7599069,24.063649 L12.5048537,14.9532715 L3.24906915,24.0637145 C2.51150266,24.7912618 1.31316489,24.7912618 0.574867021,24.0637145 C-0.16349734,23.3368871 -0.16349734,22.1580587 0.574867021,21.4312968 L9.8306516,12.3208538 L0.554388298,3.18953208 C-0.184707447,2.46198471 -0.184707447,1.28387633 0.554388298,0.557114362 C0.923537234,0.192947972 1.40771277,0.0112574801 1.8918883,0.0112574801 C2.37526596,0.0112574801 2.85944149,0.192947972 3.22865691,0.557114362 L12.5048537,9.6883706 L21.7599069,0.57792761 C22.1298537,0.214546626 22.6132314,0.0320707281 23.0974069,0.0320707281 C23.5807846,0.0320707281 24.0649601,0.214546626 24.4341755,0.57792761 C25.1732713,1.30475503 25.1732713,2.48279796 24.4341755,3.21034533 L15.1791223,12.3208538 Z"
}))))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/ProcessCard__Icon--Cross.43db358b.svg";
export { SvgComponent as ReactComponent };